import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { TransitionConfig } from 'library/constants/styles-config';

const FilterBase = styled.span`
  display: inline-block;
  padding: 7px 8px 7px 7px;
`;

const FilterActionItem = `
  cursor: pointer;
  transition: color ${TransitionConfig};
`;

export const Options = styled(FilterBase)`
`;

export const Item = styled.span`
  ${FilterActionItem};
  color: ${Colors.shade03};

  ${({ isActive }) => (isActive ? `
    cursor: default;
  ` : `text-decoration: underline;     color: ${Colors.violet};`)}
`;
